import type { ReactNode } from "react";
import type { FormFieldConfig } from "./types";

type GroupInputProps = {
    fields: FormFieldConfig[];
    renderField: (groupField: FormFieldConfig, index: number, noOfFields: number) => ReactNode;
};

const GroupInput = ({ fields, renderField }: GroupInputProps) => {
    const noOfFields = fields.length;

    return <div className="row">{fields.map((groupField, index) => renderField(groupField, index, noOfFields || 1))}</div>;
};

export default GroupInput;
